import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import { useGetInsightWidgetData } from '~/services/insights/insights-service';
import { InsightsDrawerContent } from '~/widgets/insight-widget/components/insight-drawer/components/insights-drawer-content/InsightsDrawerContent';

import { InsightIconsRoot } from '~/views/insights/components/insight-icons-root/InsightIconsRoot';
import { IconConfig } from '../InsightsFullDrawer';
import * as S from './InsightsInfo.styles';

export interface InsightsInfoProps {
  insightId: string | null;
  iconConfig?: IconConfig;
}

export const InsightsInfo = ({ insightId, iconConfig }: InsightsInfoProps) => {
  const { data, isLoading } = useGetInsightWidgetData(insightId as string);

  if (isLoading) {
    return (
      <S.LoadingWrapper data-testid="insight-info-loading">
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '100%',
                height: 40,
              },
            },
          ]}
        />
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '100%',
                height: 72,
              },
            },
          ]}
        />
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '100%',
                height: 312,
              },
            },
          ]}
        />
      </S.LoadingWrapper>
    );
  }

  if (!data?.data?.insight) {
    return (
      <S.Wrapper>
        <S.Image
          alt=""
          src="/app/static/images/empty-state/radio-telescope.png"
        />
      </S.Wrapper>
    );
  }

  return (
    <InsightsDrawerContent
      insightsData={data.data}
      showViewMore={false}
      showEntityHeader={false}
      header={() => (
        <S.Header>
          {iconConfig && <InsightIconsRoot {...iconConfig} isStarred={false} />}
          <S.Title>{data.data.insight.simple_title}</S.Title>
        </S.Header>
      )}
    />
  );
};
